import React from 'react';
import PropTypes from 'prop-types';
import { ZipCodeForm } from 'site-modules/shared/components/zip-code-form/zip-code-form';

export function EmbeddedLfEmptyView({ customConfig }) {
  const { showZipForm, creativeId, onZipSubmit } = customConfig;

  if (showZipForm) {
    return (
      <ZipCodeForm
        trackingParent={`${creativeId}-ZIP`}
        onSuccess={onZipSubmit}
        colConfig={{ zip: { xs: 6 }, btn: { xs: 'auto' } }}
        title="Enter location"
        subTitle="Enter a U.S. ZIP code for pricing near you."
        btnTitle="Continue"
        titleClassName="heading-4 mb-1"
        subTitleClassName="mb-1_5"
        zipInputClassName="size-16 py-0_5"
        btnClassName="ms-0_75"
        isErrorBelow
        fireWidgetView
      />
    );
  }

  return (
    <div className="pos-r">
      <div className="heading-3 mb-1 text-blue-50">Sorry!</div>
      <div className="mb-2">You are outside our supported search radius.</div>
    </div>
  );
}

EmbeddedLfEmptyView.propTypes = {
  customConfig: PropTypes.shape({
    showZipForm: PropTypes.bool,
    onZipSubmit: PropTypes.func.isRequired,
    leadZipFormComponent: PropTypes.elementType,
    creativeId: PropTypes.string,
  }).isRequired,
};
